import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const SuppliersQuery = gql`
    query {
        suppliers {
            id
            name
        }
    }
`;

const CreateSupplierMutation = gql`
    mutation($supplier: SupplierInput!) {
        createSupplier(supplier: $supplier) {
            id
        }
    }
`;

const UpdateSupplierMutation = gql`
    mutation($id: String!, $supplier: SupplierInput!) {
        updateSupplier(id: $id, supplier: $supplier) {
            id
        }
    }
`;

const DeleteSupplierMutation = gql`
    mutation($id: String!) {
        deleteSupplier(id: $id) {
            id
        }
    }
`;

interface IInputProps {
    children?: any;
}

interface Response {
    data: any;
}

class GetSuppliersQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
    render() {
        const { suppliers, createSupplier, updateSupplier, deleteSupplier }: any = this.props;
        return this.props.children({
            suppliers,
            createSupplier,
            updateSupplier,
            deleteSupplier
        });
    }
}

export default compose(
    graphql<IInputProps, Response>(SuppliersQuery, {
        name: 'suppliers'
    }),
    graphql<IInputProps, Response>(CreateSupplierMutation, {
        name: 'createSupplier'
    }),
    graphql<IInputProps, Response>(UpdateSupplierMutation, {
        name: 'updateSupplier'
    }),
    graphql<IInputProps, Response>(DeleteSupplierMutation, {
        name: 'deleteSupplier'
    })
)(GetSuppliersQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Suppliers/Suppliers.tsx